import { render, staticRenderFns } from "./BaseDepositButton.vue?vue&type=template&id=2f931b5c&scoped=true"
import script from "./BaseDepositButton.vue?vue&type=script&lang=js"
export * from "./BaseDepositButton.vue?vue&type=script&lang=js"
import style0 from "./BaseDepositButton.vue?vue&type=style&index=0&id=2f931b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f931b5c",
  null
  
)

export default component.exports